<section class="content">

  <div class="row homepage">
    <div class="col-lg-4 col-xs-4 text-center homepage-text">

      <h2>{{"base.welcome" | translate}}
      </h2>
      <div class="portal-name">
      <h1>PRM</h1> <h1>PORTAL</h1>
    </div>
      <h2>{{"base.ourPartnership" | translate}} 
      </h2>
    </div>

    <div class="col-lg-6 col-xs-6 landing-animation">
      <ng-lottie [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
    </div>


  </div>


</section>